import Guard from '@/services/middleware'

const DashLayout = () => import('@/layouts/DashLayout.vue')
const Home = () => import('@/views/dash/channels/Home.vue')
const Create = () => import('@/views/dash/channels/Create.vue')
const HomeChannels = () => import('@/views/dash/channels/HomeChannels.vue')
const CreateChannel = () => import('@/views/dash/channels/CreateChannel.vue')
const RegisterWhatsAppApi = () => import('@/views/dash/channels/RegisterWhatsAppApi.vue')
const ConnectChannel = () => import('@/views/dash/channels/ConnectChannel.vue')
const ConnectChannelQrcode = () => import('@/views/dash/channels/ConnectChannelQrcode.vue')
const ConnectChannelCode = () => import('@/views/dash/channels/ConnectChannelCode.vue')
const Connections = () => import('@/views/dash/channels/connections/Connections.vue')
const Flows = () => import('@/views/dash/channels/flows/Flows.vue')
const Statistics = () => import('@/views/dash/channels/statistics/Statistics.vue')

export default [
    {
        path: '/canais',
        component: DashLayout,
        beforeEnter: [
                Guard.redirectIfNotAuthenticated,
                Guard.checkModuleAccess
        ],
        children: [
            { path: '', name: 'channels.home', component: Home, meta: { title: 'Canais', permission: 2, module: 'channel_view' } },
            {
                path: 'cadastrar',
                name: 'channels.register',
                component: Create,
                meta: { title: 'Cadastrar canal', permission: 2, module: 'channel_manager' },
            },
            {
                path: ':id',
                name: 'channels.update',
                component: Home,
                meta: { title: 'Atualizar canal', permission: 2, module: 'channel_manager' },
            },
            {
                path: ':action/remover',
                name: 'channels.delete',
                component: Home,
                meta: { title: 'Remover canal?', permission: 2, module: 'channel_manager' },
            },
            {
                path: ':action/ler-qr-code',
                name: 'channels.readQrCode',
                component: Home,
                meta: { title: 'Ler QR Code', permission: 2, module: 'channel_view' },
            },
            {
                path: ':id/compartilhar-qr-code',
                name: 'channels.shareQrCode',
                component: Home,
                meta: { title: 'Compartilhar QR Code', permission: 2,  module: 'channel_manager' },
            },
            {
                path: ':id/gerenciar-sip',
                name: 'channels.gerSIP',
                component: Home,
                meta: { title: 'Gerenciar servidores SIP', permission: 2,  module: 'channel_manager' },
            },
            {
                path: 'criar',
                name: 'channels.create',
                component: CreateChannel,
                meta: { title: 'Novo canal', permission: 2,  module: 'channel_manager' },
            },
            {
                path: 'mostrar',
                name: 'channels.show',
                component: HomeChannels,
                meta: { title: 'Canais', permission: 2, module: 'channel_manager' },
            },
            {
                path: ':id/connections',
                name: 'channels.connections',
                component: Connections,
                meta: { title: 'Conexões do canal', permission: 2, module: 'channel_manager' },
            },
            {
                path: ':id/flows',
                name: 'channels.flows',
                component: Flows,
                meta: { title: 'Fluxos do canal', permission: 2, module: 'channel_manager' },
            },
            {
                path: ':id/statistics',
                name: 'channels.statistics',
                component: Statistics,
                meta: { title: 'Estatísticas do canal', permission: 2, module: 'channel_manager' },
            },
            {
                path: ':id/conectar',
                name: 'channel.connect',
                component: ConnectChannel,
                meta: { title: 'Conectar canal por QrCode', permission: 2, module: 'channel_connect' },
                children: [
                    {
                        path: 'qrcode',
                        name: 'channel.connect.qrcode',
                        component: ConnectChannelQrcode,
                        meta: { title: 'Conectar canal por QrCode', permission: 2, module:'channel_connect_qrCode' },
                    },
                    {
                        path: 'codigo',
                        name: 'channel.connect.code',
                        component: ConnectChannelCode,
                        meta: { title: 'Conectar canal por código', permission: 2, module:'channel_connect_code' },
                    },
                ],
            },
            /* {
                path: ':id/conectar/qrcode',
                name: 'channel.connect.qrcode',
                component: ConnectChannelQrcode,
                meta: { title: 'Conectar canal por QrCode', permission: 2, module:'channel_connect_qrCode' },
            },
            {
                path: ':id/conectar/codigo',
                name: 'channel.connect.code',
                component: ConnectChannelCode,
                meta: { title: 'Conectar canal por código', permission: 2, module:'channel_connect_code' },
            }, */
        ],
    },
    {
        path: '/canais/cadastrar/whatsapp/:type',
        component: RegisterWhatsAppApi,
        beforeEnter: [ Guard.checkResellerData ],
        name: 'channels.register.whatsapp',
        meta: { title: 'Vinculando canais...' },
    },
]
